import React, { useState } from 'react';
import SVGInline from 'react-svg-inline';

import useClickOutside from 'hooks/useClickOutside';

import VideoPlayerButtonHoverTag from '../../button-hover-tag';

import DropdownMenuWithItems from 'components/ui-components/share-dropdown-menu/dropdown-menu-with-items';

import './styles.less';

const shareSVG = `
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d)">
     <path fill-rule="evenodd" clip-rule="evenodd" d="M19.7615 9.70504L14.1742 4.21866C13.6861 3.73969 12.8801 4.09991 12.8801 4.79263V7.19144C6.90468 8.07813 4.45521 13.3508 4.00125 19.5813C3.96945 20.0167 4.55366 20.1672 4.7295 19.7674C6.20593 16.4185 8.55694 13.3785 12.8801 13.3626V15.7614C12.8801 16.4581 13.6861 16.8144 14.1742 16.3354L19.7615 10.853C20.0795 10.5403 20.0795 10.0178 19.7615 9.70504Z" fill="white"/>
    </g>
  <defs>
    <filter id="filter0_d" x="0" y="0" width="24" height="24" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
      <feOffset/>
      <feGaussianBlur stdDeviation="2"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
      <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
    </filter>
  </defs>
  </svg>
`;

const EmbedTopBarShareButton = props => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [hovered, setHovered] = useState(false);
  const ref = useClickOutside(() => setShowDropdown(false));

  function onShareButtonClick(e) {
    e.stopPropagation();
    setShowDropdown(!showDropdown);
  }

  return (
    <div
      ref={ref}
      className="embed-top-share-button"
      onClick={onShareButtonClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <VideoPlayerButtonHoverTag
        text="Share"
        hovered={hovered && !showDropdown}
        position="bottom"
      />
      <SVGInline svg={String(shareSVG)} />
      <DropdownMenuWithItems
        show={showDropdown}
        align="right"
        vAlign="top"
        additionalClass="embed-share-dropdown"
        hasGmailAccount={props.hasGmailAccount}
        videoIsTeamShared={props.videoIsTeamShared}
        currentUserIsOwner={props.currentUserIsOwner}
        showFacebook={false}
        video={props.video}
      />
    </div>
  );
};

export default EmbedTopBarShareButton;
